import { useEffect, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function TeamPage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const teamMembers = [
    {
      name: 'Ahmet Yılmaz',
      position: 'TEAM CAPTAIN',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20male%20engineer%20portrait%20confident%20smile%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-1&orientation=portrait',
      isLeader: true,
      bio: 'Takımın vizyonunu belirleyen ve tüm departmanları koordine eden lider. 3 yıldır Formula Student yarışlarında aktif.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Zeynep Kaya',
      position: 'MECHANICAL LEAD',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20female%20engineer%20portrait%20confident%20smile%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-2&orientation=portrait',
      bio: 'Şasi ve süspansiyon sistemlerinin tasarımından sorumlu. CAD ve analiz konusunda uzman.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Mehmet Demir',
      position: 'ELECTRONICS',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20male%20engineer%20portrait%20glasses%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting%20focused%20expression&width=280&height=380&seq=team-3&orientation=portrait',
      bio: 'Elektronik sistemler ve sensör entegrasyonundan sorumlu. PCB tasarımı ve gömülü sistemler uzmanı.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Ayşe Şahin',
      position: 'SOFTWARE LEAD',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20female%20engineer%20portrait%20confident%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-4&orientation=portrait',
      bio: 'Veri toplama, telemetri ve otonom sürüş yazılımlarının geliştirilmesinden sorumlu.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Can Öztürk',
      position: 'AERODYNAMICS',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20male%20engineer%20portrait%20confident%20smile%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-5&orientation=portrait',
      bio: 'Aerodinamik paket tasarımı ve CFD analizlerinden sorumlu. Downforce optimizasyonu uzmanı.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Elif Yıldız',
      position: 'DESIGN LEAD',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20female%20engineer%20portrait%20creative%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-6&orientation=portrait',
      bio: 'Görsel kimlik, marka yönetimi ve sponsorluk sunumlarından sorumlu kreatif lider.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Burak Arslan',
      position: 'CHASSIS',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20male%20engineer%20portrait%20confident%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-7&orientation=portrait',
      bio: 'Şasi yapısı ve güvenlik sistemlerinin tasarımından sorumlu. FEA analizi uzmanı.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Selin Aydın',
      position: 'POWERTRAIN',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20female%20engineer%20portrait%20confident%20smile%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-8&orientation=portrait',
      bio: 'Motor, transmisyon ve güç aktarma sistemlerinin optimizasyonundan sorumlu.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Emre Kılıç',
      position: 'SUSPENSION',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20male%20engineer%20portrait%20technical%20modern%20workspace%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-9&orientation=portrait',
      bio: 'Süspansiyon geometrisi ve sönümleme sistemlerinin tasarımından sorumlu.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Deniz Yurt',
      position: 'BRAKING SYSTEM',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20female%20engineer%20portrait%20focused%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-10&orientation=portrait',
      bio: 'Fren sistemi tasarımı ve performans testlerinden sorumlu güvenlik uzmanı.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Kaan Tekin',
      position: 'DATA ANALYSIS',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20male%20engineer%20portrait%20analytical%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-11&orientation=portrait',
      bio: 'Yarış verilerinin analizi ve performans optimizasyonundan sorumlu.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    },
    {
      name: 'Ece Polat',
      position: 'COMPOSITE',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20female%20engineer%20portrait%20confident%20modern%20workspace%20technical%20background%20professional%20headshot%20engineering%20student%20dark%20background%20studio%20lighting&width=280&height=380&seq=team-12&orientation=portrait',
      bio: 'Karbon fiber ve kompozit malzeme üretiminden sorumlu malzeme uzmanı.',
      social: { linkedin: '#', instagram: '#', github: '#' }
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=formula%20student%20racing%20team%20workshop%20engineers%20working%20together%20on%20race%20car%20modern%20engineering%20facility%20teamwork%20collaboration%20dark%20industrial%20background%20dramatic%20lighting%20technical%20workspace&width=1920&height=800&seq=team-hero&orientation=landscape"
            alt="Team Hero"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black"></div>
        </div>

        <div className={`relative z-10 text-center px-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h3 className="text-[#00d9ff] text-sm uppercase tracking-[0.3em] font-semibold mb-4">
            TAKIM
          </h3>
          <h1 className="text-7xl font-bold mb-6">Mühendislik Ailemiz</h1>
          <p className="text-2xl text-white/70 italic max-w-2xl mx-auto">
            40+ tutkulu mühendis, tek hedef: Mükemmel yarış aracı
          </p>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
            <div className="w-1 h-3 bg-[#00d9ff] rounded-full animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* Team Stats */}
      <section className="py-20 px-8 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { number: '40+', label: 'Takım Üyesi', icon: 'ri-team-fill' },
              { number: '8', label: 'Departman', icon: 'ri-organization-chart' },
              { number: '3', label: 'Yıllık Deneyim', icon: 'ri-trophy-fill' },
              { number: '100%', label: 'Tutku', icon: 'ri-fire-fill' }
            ].map((stat, index) => (
              <div
                key={index}
                className={`text-center p-8 bg-black/50 border border-[#333] rounded-lg hover:border-[#00d9ff] transition-all duration-500 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#00d9ff]/10 rounded-full">
                  <i className={`${stat.icon} text-3xl text-[#00d9ff]`}></i>
                </div>
                <div className="text-5xl font-bold text-[#00d9ff] mb-2">{stat.number}</div>
                <div className="text-white/60 uppercase tracking-wider text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Members Grid */}
      <section className="py-32 px-8 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl font-bold mb-6">Takım Üyelerimiz</h2>
            <p className="text-xl text-white/60 italic">Her biri alanında uzman, hepsi bir arada güçlü</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className={`group relative overflow-hidden rounded-lg transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
                }`}
                style={{ transitionDelay: `${Math.floor(index / 4) * 0.1}s` }}
              >
                <div className={`relative h-[380px] cursor-pointer ${
                  member.isLeader ? 'ring-2 ring-[#ffd700]' : 'border border-[#333]'
                }`}>
                  {/* Image */}
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-center grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
                  />

                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-60" />

                  {/* Leader Badge */}
                  {member.isLeader && (
                    <div className="absolute top-4 right-4 w-10 h-10 bg-[#ffd700] rounded-full flex items-center justify-center animate-pulse">
                      <i className="ri-star-fill text-black text-xl" />
                    </div>
                  )}

                  {/* Info on Bottom */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
                    <h3 className="text-xl font-bold text-white mb-1">{member.name}</h3>
                    <p className="text-[#00d9ff] text-xs uppercase tracking-[0.2em]">
                      {member.position}
                    </p>
                  </div>

                  {/* Hover Content */}
                  <div className="absolute inset-0 bg-black/95 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 scale-95 group-hover:scale-100 p-6">
                    <h3 className="text-2xl font-bold text-white mb-2">{member.name}</h3>
                    <p className="text-[#00d9ff] text-sm uppercase tracking-[0.2em] mb-4">
                      {member.position}
                    </p>
                    <p className="text-white/70 text-sm text-center mb-6 leading-relaxed">
                      {member.bio}
                    </p>

                    {/* Social Icons */}
                    <div className="flex gap-4">
                      <a
                        href={member.social.linkedin}
                        className="w-10 h-10 flex items-center justify-center bg-transparent border border-white/30 rounded-full hover:bg-[#00d9ff] hover:border-[#00d9ff] transition-all duration-300 group/icon cursor-pointer"
                      >
                        <i className="ri-linkedin-fill text-lg text-white group-hover/icon:text-black" />
                      </a>
                      <a
                        href={member.social.instagram}
                        className="w-10 h-10 flex items-center justify-center bg-transparent border border-white/30 rounded-full hover:bg-[#ff6b35] hover:border-[#ff6b35] transition-all duration-300 group/icon cursor-pointer"
                      >
                        <i className="ri-instagram-fill text-lg text-white group-hover/icon:text-black" />
                      </a>
                      <a
                        href={member.social.github}
                        className="w-10 h-10 flex items-center justify-center bg-transparent border border-white/30 rounded-full hover:bg-white hover:border-white transition-all duration-300 group/icon cursor-pointer"
                      >
                        <i className="ri-github-fill text-lg text-white group-hover/icon:text-black" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Team CTA */}
      <section className="py-32 px-8 bg-[#0a0a0a] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#00d9ff] rounded-full blur-[120px]"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#ff6b35] rounded-full blur-[120px]"></div>
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h2 className="text-5xl font-bold mb-6">Takıma Katıl</h2>
          <p className="text-xl text-white/70 mb-12 leading-relaxed">
            Tutkulu, yaratıcı ve çözüm odaklı mühendisler arıyoruz. 
            Formula Student yarışlarında bizimle birlikte olmak ister misin?
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="#iletişim"
              className="px-10 py-4 bg-[#00d9ff] text-black font-bold rounded-full hover:bg-[#00b8d4] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Başvuru Yap
            </a>
            <a
              href="#"
              className="px-10 py-4 bg-transparent border-2 border-white text-white font-bold rounded-full hover:bg-white hover:text-black transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Daha Fazla Bilgi
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
